import script from "./BaseInfoDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseInfoDialog.vue?vue&type=script&lang=ts&setup=true"

import "./BaseInfoDialog.vue?vue&type=style&index=0&id=ce8cfcba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.38_typescript@5.9.3__webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce8cfcba"]])

export default __exports__